import { FC, HTMLAttributes } from 'react'
import cn from 'classnames'

export const RowContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => (
  <div
    className={cn(
      'flex flex-col gap-4 border-b py-2 md:grid md:grid-cols-[35%_40%_25%] md:items-center md:gap-0',
      className
    )}
  >
    {children}
  </div>
)
